//State
import moment from 'moment';  
import axios from "axios";

export var GMBState = {
    newPost:[],
    newImage:[],
    medias:[],
    postMedia:[],
    mediaUrl:[],
   account:[],
   locations:[],
   location_updated:"",
   categoryupdated:"",
   description_updated:"",
   status_gmb:"",
   gAttributeupdate:"",
   location_categories:[],
   actual_location_attributes:[],
   possible_location_attributes:[],
   possible_attribute_value:[],
   update_splschedule:"",
   update_schedule:"",
   possible_categories:[],
   possible_services:[],
   add_location_service:"",
   locationInfo:[],
    locationSchedule:[],
    locationMedia:[],
    partner_logo:[],
    locationPrimaryCategory:[],
};


// Getter
export var GMBGetter = {
    // functions to obtain state information      ( Getters will receive the state as their 1st argument )
    getaccount: state => state.account,
    getMedias: state => state.medias,
    getMediaUrl: state => state.mediaUrl,
    uploadPost: state => state.newPost,
    postMedias: state => state.postMedia,
    uploadImages: state => state.newImage,
    getalllocationbyaccount: state => state.locations,
    getlocationbycity: state => state.locations,
    updateNombre: state => state.location_updated,
    updateDirection: state => state.location_updated,
    updateTelephone: state => state.location_updated,
    getlocationCategories: state => state.location_categories,
    // setlocationCategories: state => state.categoryupdated,
    setlocCategory: state => state.categoryupdated,
    setlocationDescription: state => state.description_updated,
    setGoogleAttribute: state => state.gAttributeupdate,
    getActualLocationAttributes: state => state.actual_location_attributes,
    getPossibleLocationAttributes: state => state.possible_location_attributes,
    getPossibleAttributevalue: state => state.possible_attribute_value,
    setLocationSplSchedule: state => state.update_splschedule,
    setLocationSchedule: state => state.update_schedule,
    getpossibleCategories: state => state.possible_categories,
    getpossibleServices: state => state.possible_services,
    addLocationService: state => state.add_location_service,
    getLocationInfo: state => state.locationInfo,
    getLocationSchedule: state => state.locationSchedule,
    getLocationMedia: state => state.locationMedia,
    getPartnerLogo: state => state.partner_logo,
    getLocationPrimaryCategory: state => state.locationPrimaryCategory,
    
};

//Actions
const user_context = JSON.parse(localStorage.getItem('user_context'));
const uid = localStorage.getItem("uid");
const pass = localStorage.getItem("pass");

export var GMBActions = {

    async getMedias ({ commit }){
        commit("gmb_request");
        var req_data = {
            "jsonrpc" : "2.0",
            "method" : "call",
            "params" : {
                "service": "object",
                "method": "execute",
                "args": [axios.defaults.db, uid,pass, "brand_whisper.location.media", "search_read", [["location_id","=",1]], [] ]
                }
        }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var getmedias = [];
                if(res.data.result.length > 0){
                    getmedias = res.data.result;
                }
                commit("gmb_medias_success", getmedias);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });

    },

    async getMediaUrl ({commit},payload){
        commit("gmb_request");
        var {
            media_id
        } = payload
        var req_data = {
            "jsonrpc" : "2.0",
            "method" : "call",
            "params" : {
                "service": "object",
                "method": "execute",
                "args": [axios.defaults.db, uid,pass, "brand_whisper.location.media", "read", [media_id], [] ]
                }
        }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var getmediaUrl = [];
                if(res.data.result.length > 0){
                    getmediaUrl = res.data.result;
                
                }
                commit("gmb_mediaUrl_success", getmediaUrl);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },
    

    async uploadPost ({commit},payload){
        commit("gmb_request");
        var {
            language,
            summary,
            topic_type,
            call_to_action_type,
            call_to_action_url,
            event_title,
            event_start_date,
            event_end_date,
            event_time,
            alert_type,
            offer_coupon_code,
            offer_redeem_url,
            offer_terms_conditions,
            media,
            row_data
        }=payload;
        var req_data = {
            "jsonrpc": "2.0",
            "method": "call",
            "params": {
                 service: 'object',
                 method: 'execute',
                 args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data],  {
                    "location_field": "add_post",
                    "language":language,
                    "summary": summary,
                    "topic_type":topic_type,
                    "call_to_action_type":call_to_action_type,
                    "call_to_action_url":call_to_action_url,
                    "event_title":event_title,
                    "event_start_date":event_start_date,
                    "event_end_date":event_end_date,
                    "event_time":event_time,
                    "alert_type":alert_type,
                    "offer_coupon_code":offer_coupon_code,
                    "offer_redeem_url":offer_redeem_url,
                   "offer_terms_conditions":offer_terms_conditions,
                    "media": [media]
                 },]

            }

        }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                var newPost = {};
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    newPost = res.data.result;
                }
                commit("gmb_newPost_success", newPost);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async uploadImages ({commit},payload){
        commit("gmb_request");
        var  {
            media_url,
            media_id,
            media_format,
            media_category,
            row_data
        } = payload
        var req_data = {
            "jsonrpc": "2.0",
            "method": "call",
            "params": {
                 service: 'object',
                 method: 'execute',
                 args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data],  {
                    "location_field": "add_media",
                    "media_format":media_format,
                    "media_category": media_category,
                    "media_url":media_url,
                    "media_id":media_id,
                 },]
            }
        }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                var newImage = {};
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    newImage = res.data.result;
                }
                commit("gmb_newImage_success", newImage);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async postMedias({commit},payload){
        commit("gmb_request");
        var {
            media,
            media_filename,
            location_id
        } = payload
        var req_data = {"jsonrpc": "2.0",
        "method": "call",
        "params": {
            "service": "object",
            "method": "execute",
            "args": [axios.defaults.db, uid, pass, "brand_whisper.location.media", "create", {
                        "media_binary": media,
                        "media_filename": media_filename,
                        "location_id": location_id,
                        } ]
            }
    }
    await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                var postmedias = {};
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    postmedias = res.data.result;
                
                }
                commit("gmb_postMedias_success", postmedias);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });

    },
    async getaccount({ commit }) {
        commit("gmb_request");
        var req_data={
            "jsonrpc": "2.0",
            "method": "call",
            "params": {
                service: 'object',
                method: 'execute',
                args: [axios.defaults.db, uid, pass, 'brand_whisper.gmbaccount', 'read_group', []
                , [], ["partner_id"], 0,0,'',false ]
            }
        }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var getaccount = [];
                var partners = [];
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    res.data.result.forEach((partner)=>{

                      if(partner.partner_id !== false){
                        partners.push({
                          "id":partner.partner_id[0], "value" : partner.partner_id[1]
                      })
                      }
                    });
                    getaccount = partners;
                }
                commit("gmb_success", getaccount);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },
    async updateNombre({ commit }, payload) {
        commit("gmb_request");
        var {
            location_field,
            description,
            location_name,
            row_data
        }=payload;

        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                       {
                           "location_field": "change_name",
                           "description":description,
                           "location_name": location_name
                        },
                    ]
               }
           };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locations = {};
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    locations = res.data.result;
                }
                commit("gmb_nameupdate_success", locations);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async updateDirection({ commit }, payload) {
        commit("gmb_request");
        var {
                location_field,
                postal_code,
                region_code,
                administrative_area,
                locality,
                address,
                row_data
            }=payload;

        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                   {
                       "location_field": "change_address",
                       "postal_code":postal_code,
                       "region_code": region_code,
                       "administrative_area":administrative_area,
                       "locality":locality,
                       "address":address
                    },
                    ]
               }
           };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locations = {};
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    locations = res.data.result;
                }
                commit("gmb_directionupdate_success", locations);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },
    async updateTelephone({ commit }, payload) {
        commit("gmb_request");
        var {
                location_field,
                primary_phone,
                additional_phones,
                row_data
            }=payload;

        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                       {
                           "location_field": location_field,
                           "primary_phone":primary_phone,
                           "additional_phones": additional_phones
                        },
                    ]
               }
           };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locations = {};
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    locations = res.data.result;
                }
                commit("gmb_telephoneupdate_success", locations);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    /*async updateTelephoneAdditional({ commit }, payload) {
        commit("gmb_request");
        var {
                location_field,
                additional_phones,
                row_data
            }=payload;

        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                       {
                           "location_field": location_field,
                           "additional_phones":additional_phones
                        },
                    ]
               }
           };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locations = {};
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    locations = res.data.result;
                }
                commit("gmb_telephoneaddupdate_success", locations);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },*/


    async getlocationCategories({ commit },payload) {
        commit("gmb_request");
       var {row_data}=payload;

        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location.google.category', 'search_read', [], ["name","category_id"],
                        0,
                        0,
                        ""
                    ]
                 }
            }

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var categories = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    categories = res.data.result;
                }else{
                    categories =[];
                }
                commit("gmb_locationcategories_success", categories);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async getpossibleCategories({ commit },payload) {
        commit("gmb_request");
       var {category_id}=payload
       var domain =[];
       if(category_id !== "" || category_id.length > 0){
            domain.push(["category_id","in",[category_id]]);
       }
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location.google.category', 'search_read', domain, ["id","display_name","category_id","name"],
                        0,
                        0,
                        ""
                    ]
                 }
                }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var possible_categories = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    possible_categories = res.data.result;
                }else{
                    possible_categories =[];
                }
                commit("gmb_possiblecategories_success", possible_categories);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async getpossibleServices({ commit },payload) {
        commit("gmb_request");
       var {google_category_ids}=payload

        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location.category.service', 'search_read', [["google_category_ids","in",[google_category_ids]]], ["service_type_id"],
                        0,
                        0,
                        ""
                    ]
                 }
                }

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var possible_services = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    possible_services = res.data.result;
                }else{
                    possible_services =[];
                }
                commit("gmb_possible_services_success", possible_services);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },


    async setlocCategory({ commit },payload) {
        commit("gmb_request");
       console.log("setlocCategory 1111", payload);
       var {
                location_field,
                primary_category,
                category_list,
                row_data
            }=payload;


        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                       {
                           "location_field": location_field,
                           "primary_category": primary_category,
                           "category_list": category_list
                        },
                    ]
               }
           }


        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var categories = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    categories = res.data.result;
                }else{
                    categories =[];
                }
                commit("gmb_setloccategory_success", categories);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async setlocationDescription({ commit },payload) {
        commit("gmb_request");
       var {
                location_field,
                profile_description,
                row_data
            }=payload;


        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                       {
                           "location_field": location_field,
                           "profile_description":profile_description

                        },
                    ]
               }
           }


        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var categories = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    categories = res.data.result;
                }else{
                    categories =[];
                }
                commit("gmb_setdescription_success", categories);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async setLocationSplSchedule({ commit },payload) {
        commit("gmb_request");
       var {
                location_field,
                start_date,
                is_closed,
                open_time_special,
                end_date,
                close_time_special,
                row_data
            }=payload;


        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                       {
                           "location_field": location_field,
                           "start_date":start_date,
                           "is_closed":is_closed,
                           "open_time_special":open_time_special,
                           "end_date": end_date,
                           "close_time_special": close_time_special

                        },
                    ]
               }
           }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var update_splschedule = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    update_splschedule = res.data.result;
                }else{
                    update_splschedule =[];
                }
                commit("gmb_update_splschedule_success", update_splschedule);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async setLocationSchedule({ commit },payload) {
        commit("gmb_request");
       var {
                location_field,
                its_open,
                row_data
            }=payload;


        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                       {
                           "location_field": location_field,
                           "its_open": its_open
                        },
                    ]
               }
           }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var update_schedule = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    update_schedule = res.data.result;
                }else{
                    update_schedule =[];
                }
                commit("gmb_update_schedule_success", update_schedule);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },


    async setGoogleAttribute({ commit },payload) {
        commit("gmb_request");
       var {
                location_field,
                google_atribute_ids,
                atribute_type,
                value,
                row_data
            }=payload;


        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], 
                       {
                           "location_field": location_field,
                           "google_atribute_ids":google_atribute_ids,//"<posible attribute location_id field>",
                           "atribute_type":atribute_type,//"<posible attribute value_type field>",
                           "value":value,//"<posible attribute values>"

                        },
                    ]
               }
           }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var categories = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    categories = res.data.result;
                }else{
                    categories =[];
                }
                commit("gmb_gattributeupdate_success", categories);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },


    async addLocationService({ commit },payload) {
        commit("gmb_request");
       var {
                location_field,
                google_services_ids,
                is_money,
                service_type_free_form,
                currency_code,
                units,
                row_data
            }=payload;

            console.log("payload :: ", payload);
            var data = {
                           "location_field": "add_service",
                           "is_money": is_money,
                           // "google_services_ids": google_services_ids,
                           // "service_type_free_form": service_type_free_form,
                           // "currency_code": currency_code,
                           // "units": units
                        };
            if(google_services_ids === undefined){
              data['service_type_free_form']=service_type_free_form;
            }else{
              data['google_services_ids']=google_services_ids;
            }

            if(is_money){
                data['currency_code']=currency_code;
                data['units']=units; 
            }

            console.log("data in add service ::: ", data);
        var req_data={
               "jsonrpc": "2.0",
               "method": "call",
               "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'update_fields', [row_data], data]
               }
           }
        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var add_location_service = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result ){
                    // getaccount = res.data.result;
                    add_location_service = res.data.result;
                }else{
                    add_location_service =[];
                }
                commit("gmb_add_location_service_success", add_location_service);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },



    async getActualLocationAttributes({ commit }, payload) {
        commit("gmb_request");
       
       var{
        row_data
       }=payload

        var req_data={
            "jsonrpc": "2.0",
            "method": "call",
            "params": {
                service: 'object',
                method: 'execute',
                args: [axios.defaults.db, uid, pass, 'brand_whisper.location.atribute', 'search_read', [["location_id","in",row_data]], [
                      "attribute_id",
                    ],
                    0,
                    0,
                    ""
                ]
             }
            }

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var attributes = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result.length>0){
                    // getaccount = res.data.result;
                    attributes = res.data.result;
                }else{
                    attributes =[];
                }
                commit("gmb_actuallocationattributes_success", attributes);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async getPossibleLocationAttributes({ commit }, payload) {
        commit("gmb_request");
       
       var{
        actual_attribute_id,
        row_data
       }=payload

        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location.google.atribute', 'search_read', [["location_id","in",row_data],["attribute_id","not in",[actual_attribute_id]]],
                          ["name","attribute_id","value_type", "atribute_value_ids"],
                        0,
                        0,
                        ""
                    ]
                 }
                }

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var attributes = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result.length>0){
                    // getaccount = res.data.result;
                    attributes = res.data.result;
                }else{
                    attributes =[];
                }
                commit("gmb_possibleattributes_success", attributes);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async getPossibleAttributevalue({ commit }, payload) {
        commit("gmb_request");
       
       var{
        atribute_id,
        row_data
       }=payload

        var req_data={
                        "jsonrpc": "2.0",
                        "method": "call",
                        "params": {
                          "context":user_context.user_context,
                          "model": "brand_whisper.location.atribute.value",
                          "domain":[["atribute_id","in",atribute_id]],//2
                          "fields":["value"],
                          "sort": "",
                          "limit": 0
                         }
                        }

        await this._vm.$http
            .post("/web/dataset/search_read", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var attributes = [];
                if(res.data.error){
                    commit("gmb_error")    
                }
                if(res.data.result.length>0){
                    // getaccount = res.data.result;
                    attributes = res.data.result;
                }else{
                    attributes =[];
                }
                commit("gmb_possibleattributevalue_success", attributes);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },


    async getalllocationbyaccount({ commit }, payload) {
        commit("gmb_request");
        var {
            partner_id
        }=payload;
        var domain = [];
        if(partner_id.length>0){
            domain.push(["partner_id", "=", partner_id])
        }
        var req_data={
            "jsonrpc": "2.0",
            "method": "call",
            "params": {
                service: 'object',
                method: 'execute',
                args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'search_read', domain, ["id","locationName","description","primaryPhone","websiteUrl","maps_url","profile_description","address","comunidad_autonoma","city","zip_code","status","openingDate","hour_ids","partner_id"],
                    0,
                    0,
                    ""
                ]
              }
            };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locations = [];
                var partners = [];
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    locations = res.data.result;
                }
                commit("gmb_location_success", locations);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },
    async getlocationbycity({ commit }, payload) {
        commit("gmb_request");
        var {
            partner_id,
            citys
        }=payload;
        var domain = [];
        if(partner_id.length>0){
            domain.push(["partner_id", "=", partner_id])
        }
        if(citys.length>0){
            domain.push(["city", "in", citys])
        }
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'search_read', domain, ["id","locationName","description","primaryPhone","websiteUrl","maps_url","profile_description","address","comunidad_autonoma","city","zip_code","status","openingDate","hour_ids","partner_id"],
                        0,
                        0,
                        ""
                    ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locations = [];
                var partners = [];
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    locations = res.data.result;
                }
                commit("gmb_location_success", locations);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },
    async getLocationInfo({ commit }, payload) {
        commit("gmb_request");
        var {
            location_id
        }=payload;
        var domain = [];
        
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'search_read', [["id", "=", location_id]], ["id","locationName","place_id","regionCode","description","primaryPhone","websiteUrl","maps_url","profile_description","address","comunidad_autonoma","city","zip_code","status","openingDate"],
                        0,
                        0,
                        ""
                    ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locationInfo = [];
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    locationInfo = res.data.result;
                }
                commit("gmb_locationInfo_success", locationInfo);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },
    async getLocationSchedule({ commit }, payload) {
        commit("gmb_request");
        var {
            location_id
        }=payload;

        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location.hour', 'search_read', [["location_id", "=", location_id]], ["id","open_time","close_time","close_day","open_day"],
                        0,
                        0,
                        ""
                    ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locationSchedule = [];
                
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    locationSchedule = res.data.result;
                }
                commit("gmb_locationSchedule_success", locationSchedule);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async getLocationMedia({ commit }, payload) {
        commit("gmb_request");
        var {
            location_id
        }=payload;
        
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location.media', 'search_read', [["location_id", "=", location_id]], ["category","media_format","media_url","id"],
                        0,
                        0,
                        ""
                    ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locationMedia = [];
                
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    locationMedia = res.data.result;
                }
                commit("gmb_locationMedia_success", locationMedia);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async getPartnerLogo({ commit }, payload) {
        commit("gmb_request");
        var {
            location_id
        }=payload;
        
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'res.partner', 'search_read', [["id", "=", location_id]], [
                          "image_1920",
                        ],
                        0,
                        0,
                        ""
                    ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var partner_logo = [];
                
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    partner_logo = res.data.result;
                }
                commit("gmb_partner_logo_success", partner_logo);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },

    async getLocationPrimaryCategory({ commit }, payload) {
        commit("gmb_request");
        var {
            location_id
        }=payload;
        
        var req_data={
                "jsonrpc": "2.0",
                "method": "call",
                "params": {
                    service: 'object',
                    method: 'execute',
                    args: [axios.defaults.db, uid, pass, 'brand_whisper.location.category', 'search_read', [["location_id", "=", location_id],["primary_category", "=", true]], ["name","display_name","category_id"],
                        0,
                        0,
                        ""
                    ]
                  }
                };

        await this._vm.$http
            .post("/jsonrpc", req_data)
            .then(res => {
                //////console.log("res.data in account::", res.data);
                var locationPrimaryCategory = [];
                
                if(res.data.result.length > 0){
                    // getaccount = res.data.result;
                    locationPrimaryCategory = res.data.result;
                }
                commit("gmb_locationPrimaryCategory_success", locationPrimaryCategory);
                return res;
            })
            .catch(err => {
                commit("gmb_error")
                return err;
            });
    },


}



//mutations
export var GMBMutations = {
    gmb_request(state) {
        state.status_gmb = "loading";
    },
    gmb_success(state, payload) {
        state.status_gmb = "success";
        const accounts = payload;
        state.account = accounts;
    },
    gmb_medias_success(state,payload) {
        state.status_gmb = "success";
        const medias = payload;
        state.medias = medias 
    },
    gmb_newPost_success(state,payload) {
        state.status_gmb = "success";
        const newPost = payload;
        state.newPost = newPost
    },
    gmb_newImage_success(state,payload){
        state.status_gmb = "success"
        const newImage = payload;
        state.newImage = newImage
    },
    gmb_postMedias_success(state,payload){
        state.status_gmb = "success"
        const postMedia = payload;
        state.postMedia = postMedia
    },
    gmb_mediaUrl_success(state,payload){
        state.status_gmb = "success"
        const mediaUrl = payload;
        state.mediaUrl = mediaUrl
    },
    gmb_location_success(state, payload) {
        state.status_gmb = "success";
        const locations = payload;
        state.locations = locations;
    },
    gmb_nameupdate_success(state, payload) {
        state.status_gmb = "success";
        const location = payload;
        state.location_updated = location;
    },
    gmb_directionupdate_success(state, payload) {
        state.status_gmb = "success";
        const location = payload;
        state.location_updated = location;
    },
    gmb_telephoneupdate_success(state, payload) {
        state.status_gmb = "success";
        const location = payload;
        state.location_updated = location;
    },
    gmb_telephoneaddupdate_success(state, payload) {
        state.status_gmb = "success";
        const location = payload;
        state.location_updated = location;
    },
    gmb_locationcategories_success(state, payload) {
        state.status_gmb = "success";
        const categories = payload;
        state.location_categories = categories;
    },
    gmb_setloccategory_success(state, payload) {
        state.status_gmb = "success";
        const categories = payload;
        state.categoryupdated = categories;
    },
    gmb_setdescription_success(state, payload) {
        state.status_gmb = "success";
        const desc = payload;
        state.description_updated= desc;
    },
    gmb_gattributeupdate_success(state, payload) {
        state.status_gmb = "success";
        const attribute = payload;
        state.gAttributeupdate= attribute;
    },
    gmb_actuallocationattributes_success(state, payload) {
        state.status_gmb = "success";
        const attributes = payload;
        state.actual_location_attributes= attributes;
    },
    gmb_possibleattributes_success(state, payload) {
        state.status_gmb = "success";
        const attributes = payload;
        state.possible_location_attributes= attributes;
    },
    gmb_possibleattributevalue_success(state, payload) {
        state.status_gmb = "success";
        const attributes = payload;
        state.possible_attribute_value= attributes;
    },
    gmb_update_splschedule_success(state, payload) {
        state.status_gmb = "success";
        const update_splschedule = payload;
        state.update_splschedule= update_splschedule;
    },
    gmb_possiblecategories_success(state, payload) {
        state.status_gmb = "success";
        const possible_categories = payload;
        state.possible_categories= possible_categories;
    },
    gmb_possible_services_success(state, payload) {
        state.status_gmb = "success";
        const possible_services = payload;
        state.possible_services= possible_services;
    },
    gmb_add_location_service_success(state, payload) {
        state.status_gmb = "success";
        const add_location_service = payload;
        state.add_location_service= add_location_service;
    },
    gmb_update_schedule_success(state, payload) {
        state.status_gmb = "success";
        const update_schedule = payload;
        state.update_schedule= update_schedule;
    },
    gmb_locationInfo_success(state, payload) {
        state.status_gmb = "success";
        const locationInfo = payload;
        state.locationInfo= locationInfo;
    },
    gmb_locationSchedule_success(state, payload) {
        state.status_gmb = "success";
        const locationSchedule = payload;
        state.locationSchedule= locationSchedule;
    },
    gmb_locationMedia_success(state, payload) {
        state.status_gmb = "success";
        const locationMedia = payload;
        state.locationMedia= locationMedia;
    },
    gmb_partner_logo_success(state, payload) {
        state.status_gmb = "success";
        const partner_logo = payload;
        state.partner_logo= partner_logo;
    },
    gmb_locationPrimaryCategory_success(state, payload) {
        state.status_gmb = "success";
        const locationPrimaryCategory = payload;
        state.locationPrimaryCategory= locationPrimaryCategory;
    },
    gmb_error(state) {
        state.status_gmb = "error";
    },
};
